import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  /* Belt-and-suspenders: Wrapper below already has overflow: hidden, but
     clipping at the root too means no surprise body-level scrollbar from a
     stray child that escapes the chain. The page's own scrollable areas
     (Content via overflow:auto, TanstackTable etc.) still scroll
     internally as intended. */
  overflow: hidden;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  /* The chrome bars (header / stepper / toolbar) sit at the top as flex
     children; only <Content> below scrolls. Prevents the whole page from
     scrolling and pushing the chrome out of view. */
  overflow: hidden;

  .clearer {
    clear: both;
  }
`;

export const NavbarContainer = styled.nav`
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  height: 68px;
  box-shadow: 0px 4px 10px 0px #0000000d;
  background-color: ${({ theme }) => theme.colors.common.white};
  padding: 0 20px;

  & .toggler {
    transition: 0.4s ease-in-out all;
    transform: ${({ open }) => (!open ? 'rotateY(180deg)' : 'rotateY(0)')};
  }

  & .logo {
    width: 77px;
    height: 17px;
    margin-left: 27px;
  }

  & svg {
    cursor: pointer;
  }
`;

export const SearchWrapper = styled.label`
  width: 314px;
  max-width: 329px;
  height: 42px;
  margin-left: 175px;
  ${({ isWhite, theme }) =>
    isWhite
      ? `
  background-color: var(--mantine-color-body);
  border: 1px solid ${theme.colors.border.default};
`
      : `
  background-color: ${theme.colors.background.default};
`}
  display: flex;
  flex: stretch;
  align-items: center;
  border-radius: 10px;
  padding-left: 15px;
  gap: 10px;

  &.md {
    height: 37px;
    max-width: 300px;
    border-radius: 8px;

    input {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &.sm {
    height: 32px;
    max-width: 250px;
    border-radius: 6px;

    input {
      font-size: 18px;
      line-height: 24px;
    }
  }

  &.xs {
    height: 25px;
    max-width: 200px;
    border-radius: 4px;

    input {
      font-size: 14px;
      line-height: 20px;
    }
  }

  & input {
    background-color: transparent;
    border: none;
    outline: none;
    border: none;
    outline: none;
    height: 100%;
    font-size: ${({ theme }) => theme.fonts.text['font-size']};
    line-height: ${({ theme }) => theme.fonts.text['line-height']};
    font-weight: ${({ theme }) => theme.fonts.text['font-weight']};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  & input::placeholder {
    color: ${({ theme }) => theme.colors.border.default};
  }
`;

export const SidebarContainer = styled.aside`
  width: 100%;
  height: 68px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  box-shadow: 0px 4px 4px 0px #cfcfcf40;

  padding: 8px 32px;

  background-color: var(--mantine-color-body);
  transition: 0.4s ease-in-out all;
  .logo-link {
    display: flex;
    .logo {
      width: 110px;
      height: 36px;
    }
  }

  .items {
    display: flex;
    align-items: center;
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 40px 0;
  padding: 0;
`;

export const Item = styled.li`
  width: ${({ open }) => (open ? '100%' : '48px')};
  display: flex;
  margin-top: 6px;
`;

export const Link = styled(NavLink)`
  display: flex;
  width: 100%;
  align-items: center;
  height: 48px;
  gap: ${({ open }) => (open ? '14px' : '0')};
  padding: ${({ open }) => (open ? '0 14px' : '0')};
  text-decoration: none;
  transition: 0.2s ease-in-out all;

  ${({ open }) => !open && 'justify-content: center;'}

  border-radius: ${({ theme }) => theme.borders.badge};
  color: ${({ theme }) => theme.colors.text.secondary};

  h3 {
    transition: 0.2s ease-in-out all;
    width: ${({ open }) => (open ? 'auto' : '0')};
    opacity: ${({ open }) => (open ? '1' : '0')};
  }

  & svg {
    color: ${({ theme }) => theme.colors.text.secondary};
    transition: 0.2s ease-in-out all;

    & path {
      transition: 0.2s ease-in-out all;
      fill: ${({ theme }) => theme.colors.text.secondary}!important;
    }
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.background.action};
    color: ${({ theme }) => theme.colors.common.white};

    & svg {
      color: ${({ theme }) => theme.colors.common.white};

      & path {
        fill: ${({ theme }) => theme.colors.common.white}!important;
      }
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent.hover};
    color: ${({ theme }) => theme.colors.background.action};

    & svg {
      color: ${({ theme }) => theme.colors.background.action};

      & path {
        fill: ${({ theme }) => theme.colors.background.action}!important;
      }
    }
  }
`;

export const ExtraFoter = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Content = styled.main`
  transition: 0.4s ease-in-out all;
  flex: 1;
  min-height: 0;
  overflow: auto;
`;
